import * as types from './types';

const initialState = {
  quoteTemplates: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_QUOTE_TEMPLATES:
      return { quoteTemplates: action.data };
    case types.GET_QUOTE_TEMPLATES:
      // Falls through.
    default:
      return state;
  }
};
